import { useEffect, useState } from "react";

export const defaultMessages = {
    ERR_NETWORK: 'Unable to connect to the server. Please try again later.',
    404: 'Request URL Not found.',
    422: 'Invalid input. Please check and try again.',
    500: 'Internal Server error. Try again later.',
    401: 'Session expired. Please login again.',
    403: 'You are not authorized to perform this action.',
}

export const roleToPath = {
    "admin": "/admin/dashboard",
    "sales_executive": "/sales-executive/dashboard",
    "purchase_manager": "/purchase-manager/dashboard",
    "warehouse_manager": "/warehouse-manager/dashboard",
};

export const USER_ROLES = [
    { "label": "Sales Executive", "value": "sales_executive" },
    { "label": "Warehouse Manager", "value": "warehouse_manager" },
    { "label": "Purchase Manager", "value": "purchase_manager" },
    { "label": "Dispatch Executive", "value": "dispatch_executive" },
    { "label": "Warehouse Organizer", "value": "warehouse_organizer" },
]
export const ROLES = {
  SALES_EXECUTIVE: "sales_executive",
  WAREHOUSE_MANAGER: "warehouse_manager",
  PURCHASE_MANAGER: "purchase_manager",
  DISPATCH_EXECUTIVE: "dispatch_executive",
  WAREHOUSE_ORGANIZER: "warehouse_organizer",
};
export const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);

    return isMobile;
};

export const UNIT_OPTIONS = [
    { "label": "NOS", "value": "NOS" },
    { "label": "PCS", "value": "PCS" }
]

export const DASHBOARD_FILTER_OPTIONS = [
    { "label": "Yearly", "value": "yearly" },
    { "label": "Monthly", "value": "monthly" },
    { "label": "Weekly", "value": "weekly" },
]

export const DASHBOARD_PIE_CHART_FILTER_OPTIONS = [
    { "label": "7 Days", "value": "7" },
    { "label": "15 Days", "value": "15" },
    { "label": "30 Days", "value": "30" },
]